import { Accordion } from 'components/Accordion';
import { OpenQuestionOutcome } from 'services/conversations/types';
import { Box, Divider, SxProps, Theme, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { OpenEndedQuestionsOutcome } from './OpenEndedQuestionsOutcome';
import { toPercentage } from 'utils/calculations';
import { useTracking } from 'services/tracking/hooks';
import { TrackingEventName } from 'services/tracking/constants';

const infoIcon: SxProps<Theme> = {
  ml: 1.25,
  alignSelf: 'center'
};

type Props = {
  openQuestionOutcomes: OpenQuestionOutcome[];
  preferredAnswersScore?: number | null;
};

const OpenEndedQuestionsAccordion: React.FC<Props> = ({
  openQuestionOutcomes,
  preferredAnswersScore
}) => {
  const { track } = useTracking();

  return (
    <Accordion
      title={
        <>
          <Typography component="span">Scorecard</Typography>
          <InfoOutlined fontSize="small" sx={infoIcon} />
          <Box flex={1} />
          {preferredAnswersScore !== null &&
            preferredAnswersScore !== undefined && (
              <Typography component="span" color="customGrey.dark">
                {toPercentage(preferredAnswersScore)}
              </Typography>
            )}
        </>
      }
      onClick={() => {
        track(TrackingEventName.CampaignDashboardConversationOptionalSummary);
      }}
    >
      <Box>
        {openQuestionOutcomes.map((outcome, index) => (
          <Box key={index}>
            <OpenEndedQuestionsOutcome openQuestionOutcome={outcome} />
            {index !== openQuestionOutcomes.length - 1 && (
              <Divider sx={{ my: 2 }} />
            )}
          </Box>
        ))}
      </Box>
    </Accordion>
  );
};

export { OpenEndedQuestionsAccordion };
